import { photoLayoutConfig } from '~/components/photoLayoutConfig';
import { PhotoLayout } from './PhotoLayout';

export function LeftSideOfRoof() {
  return <PhotoLayout {...photoLayoutConfig['roofLeft']} />;
}
